import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Visitor } from 'src/app/models/visitor';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { saveAs } from 'file-saver';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';
import { MatDialog } from '@angular/material/dialog';
import { PreApprovedVisitorDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/pre-approved-visitor-dialog/pre-approved-visitor-dialog.component';
import { UserRegDetails } from 'src/app/models/user';
import * as moment from 'moment-timezone';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
@Component({
  selector: 'app-visitor-dashboard-table',
  templateUrl: './visitor-dashboard-table.component.html',
  styleUrls: ['./visitor-dashboard-table.component.scss'],
})
export class VisitorDashboardTableComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) dataSource: MatTableDataSource<Visitor>;
  @Output() initVisitorGateEntry = new EventEmitter<boolean>();
  @Output() showVisitorDetail = new EventEmitter<any>();
  @Output() markAsArrived = new EventEmitter<any>();
  @Input() set visitorTableData(val: Visitor[]) {
    this.temp = val;
    this.filtered = val;
    this.filteredDataSource = new MatTableDataSource(this.temp);
    this.onUpdateExistingDataTable();
  }
  @Input() set isShowHeader(val: boolean) {
    this.showHeader = val;
  }
  @Input() set orgUserData(val: UserRegDetails[]) {
    this.orgUsers = val;
  }
  @Input() set isVisitorDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }
  orgUsers: UserRegDetails[];
  showHeader = true;
  filteredDataSource: MatTableDataSource<Visitor>;
  rowIndex = 0;
  isShowDetails = false;
  expandedDetail = '';
  role: string = null;
  isLoggedInUser = false;
  displayedColumns = [
    'name',
    'date',
    'time',
    'host',
    'purpose',
    'security',
    'Details',
  ];
  temp: Visitor[];
  filtered: Visitor[];
  screenSize: ScreenType;
  constructor(
    private screen: AumyeResponsiveScreenService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private encryptionService: EncryptionService
  ) {
    this.role = this.encryptionService.getCurrentUser().role?.toLowerCase();
    this.isLoggedInUser = this.role == 'user';
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
    setTimeout(() => {
      this.filteredDataSource.paginator = this.paginator;
      this.filteredDataSource.sort = this.sort;
    });
  }
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.filteredDataSource.data = this.temp.filter((visitor) => {
      const firstNameMatch = visitor.firstName
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const lastNameMatch = visitor.lastName
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const fullNameMatch = `${visitor.firstName
        .trim()
        .toLowerCase()} ${visitor.lastName.trim().toLowerCase()}`
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const hostMatch = visitor.hostName
        .toString()
        .toLowerCase()
        .includes(filterValue);

      const phoneNumberMatch = visitor.phoneNumber
        ? visitor.phoneNumber.toString().toLowerCase().includes(filterValue)
        : '';

      const emailMatch = visitor.email
        ? visitor.email.toString().toLowerCase().includes(filterValue)
        : '';

      const visitorIdMatch = visitor.visitorID.toString().includes(filterValue); // Assuming visitorId is a number

      return (
        firstNameMatch ||
        lastNameMatch ||
        fullNameMatch ||
        visitorIdMatch ||
        hostMatch ||
        phoneNumberMatch ||
        emailMatch
      );
    });
  }
  hostName = '';
  onShowDetails(val: Visitor) {
    this.isShowDetails = true;
    this.expandedDetail = val.visitorID;
    this.showVisitorDetail.emit(val);
  }
  selectedStatus = '-1';
  onChangeDataTable(event: any) {
    this.selectedStatus = event.value;
    const selectedStatus = +event.value; // Convert to number
    if (selectedStatus === -1) {
      // Show all incidents
      this.filteredDataSource.data = this.temp;
    } else {
      // Filter based on incidentStatus
      this.filteredDataSource.data = this.temp.filter(
        (incident: Visitor) => incident.securityStatus === selectedStatus
      );
    }
  }
  onUpdateExistingDataTable() {
    const selectedStatus = +this.selectedStatus;
    if (selectedStatus === -1) {
      // Show all incidents
      this.filteredDataSource.data = this.temp;
    } else {
      // Filter based on incidentStatus
      this.filteredDataSource.data = this.temp.filter(
        (incident: Visitor) => incident.securityStatus === selectedStatus
      );
    }
  }
  onActionPreApproved(val: Visitor) {
    if (val.isPreApproved == 'true') {
      // this.visID = val.visitorID;
      const dialogRef = this.dialog.open(PreApprovedVisitorDialogComponent, {
        disableClose: true,
        width: '1080px',
        data: val,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const matchedUser = this.orgUsers.find(
            (user) => user.userId.toLowerCase() === val.hostUserId.toLowerCase()
          );
          this.hostName = matchedUser.firstname + ' ' + matchedUser.lastname;
          result['hostEmail'] = matchedUser.email;
          result['hostUserId'] = matchedUser.userId;
          const item = {
            HostName:
              matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
            HostUserId: matchedUser.userId,
            HostEmail: matchedUser.email,
            HostPhone: matchedUser.phoneNumber,
          };
          result.selectedHosts = [item];

          this.markAsArrived.emit(result);
          console.log('Check mee 222', result);
        }
      });
    }
  }
  onCreateVisitorGateEntry() {
    this.initVisitorGateEntry.emit();
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.displayedColumns,
      event.previousIndex,
      event.currentIndex
    );
  }
  downloadCSV() {
    const data: any = this.temp;
    const replacer = (key: any, value: any) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' });
    saveAs(blob, 'myFile.csv');
  }
  getFormatedDate(val: any) {
    // let localDate = new Date(val);
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  getFormattedDateTime(val: any) {
    const inputTimezone = 'UTC';
    // const date = moment(val, moment.ISO_8601);
    const date = moment.tz(val, moment.ISO_8601, inputTimezone);
    const currentTimezone = moment.tz.guess();
    date.tz(currentTimezone);
    const timeDifference = date.fromNow();
    return timeDifference;
  }
  convertUtcToLocal(utcDateTime: string): string {
    // Create a Date object from the UTC datetime string
    const date = new Date(utcDateTime);

    // Convert to local time
    const localDateTime = date.toLocaleString(); // Automatically converts to the local timezone

    // Format the local date using Angular's DatePipe (you can customize the format)
    const formattedDate = this.datePipe.transform(localDateTime, 'medium'); // 'medium' is a predefined format

    return formattedDate || '';
  }
  ScreenType = ScreenType;
}
